export default __webpack_public_path__ + "static/media/guru.86578151.jpg";